import { h } from 'preact'
import ButtonControl from '../button-control'
import Panel from '../panel'
import Icon from '../assets'
import SearchBox from '../search-box/SearchBox'
import PillContainer from '../pills/PillContainer'
import Pill from '../pills/Pill'
import AppliedFilter from '../articles/AppliedFilter'
import { Filter, Filters, FilterSelector } from './index'

type Props = {
  filterSelectors: Array<FilterSelector>,
  filters?: Filters,
  onFilterChange: (filter: string, payload: Array<Filter>) => void,
  onClearFilterCriteria: () => void,
  withSearch?: boolean
}

function getAppliedFilters (filters: Filters): Array<Filter> {
  return Object.keys(filters)
    .filter((key: string) => filters[key].length) // filters that are not empty
    .map((key: string) => filters[key][0])
}

const OverviewFilters = ({ filterSelectors, filters, onFilterChange, onClearFilterCriteria, withSearch } : Props) => {
  const appliedFilters: Array<Filter> | [] = filters ? getAppliedFilters(filters) : []
  const areFiltersApplied = appliedFilters.length > 0

  return (
    <div>
      <Panel>
        <div class='overview__filters-container'>
          {filterSelectors.map((filterSelector: FilterSelector) => {
            const FilterComponent = filterSelector.component

            const selected = appliedFilters.filter((appliedFilter: Filter) => appliedFilter.type === filterSelector.key)[0]

            const props = {
              type: filterSelector.displayName,
              items: filterSelector.data,
              onFilterChange: (e: { target: { getAttribute: (arg0: string) => any; textContent: any } }) => onFilterChange(filterSelector.key, [{ id: e.target.getAttribute('value'), name: e.target.textContent, type: filterSelector.key }]),
              selected: selected && {
                name: selected.name
              }
            }

            return <FilterComponent {...props} />
          })}
          { withSearch && <SearchBox
            value={filters?.search[0] ? filters.search[0].id : ''}
            placeholder='Search in title and content'
            onSubmit={(value: string) => onFilterChange('search', [{ id: value, name: value, type: 'search' }])} />}
        </div>
      </Panel>
      {
        areFiltersApplied &&
          <PillContainer>
            {
              appliedFilters.map(({ type, name }) =>
                <Pill>
                  <AppliedFilter type={type} name={name} />
                  <Icon customClass={`qa-dismiss-${type}-filter-pill`} icon='close' width={16} height={16} onClick={() => onFilterChange(type, [])} />
                </Pill>
              )
            }
            <ButtonControl
              class='overview__filters-clear'
              title='Clear selection'
              variant='warning'
              onClick={onClearFilterCriteria}
            />
          </PillContainer>
      }
    </div>
  )
}

export default OverviewFilters
